export const MAX_POST_CONTENT_LENGTHApi = 16000;
export const MAX_POST_ATTACHMENTS_COUNTApi = 15;
export const MAX_ATTACHMENT_FILE_SIZE_IN_BYTESApi = 104857600;
export const MAX_ATTACHMENT_FILE_FILENAME_LENGTHApi = 255;
export var PostOwnerTypeApi;
(function (PostOwnerTypeApi) {
    PostOwnerTypeApi["GROUP_MEMBER"] = "group_member";
    PostOwnerTypeApi["USER"] = "user";
})(PostOwnerTypeApi || (PostOwnerTypeApi = {}));
export var PostActionApi;
(function (PostActionApi) {
    PostActionApi["POST_DELETE"] = "post_delete";
    PostActionApi["POST_UNDELETE"] = "post_undelete";
    PostActionApi["DISABLE_DOWNVOTE_DELETION"] = "disable_downvote_deletion";
})(PostActionApi || (PostActionApi = {}));
export var PostActionDetailApi;
(function (PostActionDetailApi) {
    PostActionDetailApi["REMOVE_REASON"] = "remove_reason";
})(PostActionDetailApi || (PostActionDetailApi = {}));
export var PostActionLogsOrderApi;
(function (PostActionLogsOrderApi) {
    PostActionLogsOrderApi["ID_DESC"] = "id_desc";
    PostActionLogsOrderApi["ID_ASC"] = "id_asc";
})(PostActionLogsOrderApi || (PostActionLogsOrderApi = {}));
